import { api } from './api-client';

export type InventoryRunStatus = 'DRAFT' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELLED';

export interface InventoryRun {
  id: string;
  inventoryNumber: string;
  inventoryDate: string;
  status: InventoryRunStatus;
  scope?: string;
  assignee?: string | null;
  totalAssets: number;
  matchedCount: number;
  unmatchedCount: number;
  surplusCount: number;
}

export interface ScanResult {
  /** COUNTED when asset was in the run's item list; SURPLUS when out of scope. */
  status: 'COUNTED' | 'SURPLUS' | 'DUPLICATE';
  assetNumber: string;
  assetName?: string;
  message?: string;
}

export async function fetchInventoryRuns(): Promise<InventoryRun[]> {
  const { data } = await api.get<InventoryRun[]>('/finance/assets/inventory');
  return data;
}

/**
 * Scan one asset into a run. Backend writes `COUNTED` if the item was in
 * scope, `SURPLUS` if it was scanned but not expected. Already-COMPLETED
 * runs reject.
 */
export async function scanAsset(
  runId: string,
  assetNumber: string,
): Promise<ScanResult> {
  const { data } = await api.post<ScanResult>(
    `/finance/assets/inventory/${runId}/scan`,
    { assetNumber },
  );
  return data;
}

export async function completeRun(runId: string): Promise<InventoryRun> {
  const { data } = await api.post<InventoryRun>(
    `/finance/assets/inventory/${runId}/complete`,
  );
  return data;
}
